module.exports = __webpack_public_path__ + "img/toyota.4633edce.png";